var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C9.81752 2.16736e-08 11.5809 0.618887 12.9997 1.75477C14.4186 2.89065 15.4083 4.47581 15.8061 6.24927C16.2038 8.02273 15.9858 9.87876 15.188 11.5118C14.3902 13.1448 13.06 14.4575 11.4166 15.2337C9.77316 16.0099 7.91441 16.2034 6.14636 15.7823C4.3783 15.3612 2.80635 14.3505 1.6893 12.9168C0.572253 11.4831 -0.023299 9.71173 0.000697284 7.89438C0.0246935 6.07702 0.666808 4.322 1.82132 2.91827L8 8V0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.69d418df3aa567aa635bee31d8ca93a5.svg";
export { ForwardRef as ReactComponent };